<template>
  <div class="container">
    <div class="form-block">
      <LoginForm />
    </div>
  </div>
</template>


<script>
  import LoginForm from '@/components/Forms/Login'

  export default {
    components: {
      LoginForm
    },

  };
</script>

<style>

</style>